import { isEmpty } from 'lodash';

export const SET_PROJECT_SOFTWARE = 'SET_PROJECT_SOFTWARE';
export const SET_PROJECTS_LIST = 'SET_PROJECTS_LIST';
export const SET_PROJECTS_LIST_SKIP = 'SET_PROJECTS_LIST_SKIP';
export const PROJECTS_TAG = 'Projects';
export const TRANSFORMATIONS_TAG = 'Transformations';
export const PROJECTS_LIST_LIMIT = 10;
export const SOFTWARE_TAG = 'Software';
export const OCCURRENCE_LOCATION_TAG = 'OccurrenceLocations';

/**
 * Sets the list of projects
 * @param data
 * @param total
 * @returns {{type: string, list: *, total: *}}
 */
export const setProjectsList = ({ data = [], total = 0 }) => {
  return {
    type: SET_PROJECTS_LIST,
    data,
    total
  };
};

export const setProjectsListSkip = skip => {
  return {
    type: SET_PROJECTS_LIST_SKIP,
    skip
  };
};

/**
 * Set software
 * @param software
 * @returns {{type: string, software: *}}
 */
export const setProjectSoftware = software => {
  return {
    type: SET_PROJECT_SOFTWARE,
    software
  };
};

/**
 * Gets the list of software that can be associated to project occurrences
 * @returns {Function}
 */
export const getProjectSoftware = () => {
  return async (dispatch, getState, { apiClient }) => {
    const softwares = await apiClient.call(SOFTWARE_TAG, 'getSoftware');
    dispatch(setProjectSoftware(softwares));
  };
};

/**
 * Gets the list of projects from the API.
 * @param force
 * @returns {Function}
 */
export const getProjectsList = (force = false) => {
  return async (dispatch, getState, { apiClient }) => {
    if (isEmpty(getState().projects.list.data) || force === true) {
      const projects = await apiClient.call(PROJECTS_TAG, 'listProjects', {
        $limit: PROJECTS_LIST_LIMIT,
        $skip: getState().projects.list.skip
      });
      dispatch(setProjectsList(projects));
    }
  };
};

/**
 * Forces a refresh of the list of projects
 * @returns {Function}
 */
export const invalidateProjectsList = () => {
  return (dispatch, getState, { apiClient }) => {
    dispatch(getProjectsList(true));
  };
};

export const changeProjectListPagination = skip => {
  return async (dispatch, getState, { apiClient }) => {
    dispatch(setProjectsListSkip(skip));
    dispatch(getProjectsList(true));
  };
};



// WEBPACK FOOTER //
// ./src/scenes/projects/data/actions.js